import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./MobileFAB";

export default function PublicLayout() {
  // Disable right-click on images across public pages
  useEffect(() => {
    const handler = (e) => {
      if (e.target && e.target.tagName === "IMG") e.preventDefault();
    };
    document.addEventListener("contextmenu", handler);
    return () => document.removeEventListener("contextmenu", handler);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-warm-gradient">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {/* Spacer for the mobile bottom bar so it never overlaps the footer / map / final text */}
      <div className="md:hidden h-16" aria-hidden />
      <FloatingActions />
    </div>
  );
}
